import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import _ from 'lodash'
import moment from 'moment'
import { getCrm, numberFormat, toBuddhistYear } from 'utils/app.utils'
import { forceTextOnDateCells } from 'utils/excel.utils'



async function ExportToExcel({
    data,
    filter,
    t,
    doctors,
}: {
    data: { rows: any[]; rowLab: any[]; rowDf: any[] }
    filter: any
    t: any
    doctors?: { dentistId: number; dentistFullname: string }[]
}) {
    const doctorName = (doctorId: any) =>
        _.get(_.find(doctors, { dentistId: Number(doctorId) }), 'dentistFullname') || ''
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet(t('REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE'))
    const hasCrm = getCrm()
    const titleMergeCols = hasCrm ? 24 : 22

    // Title
    const titleRow = sheet.addRow([t('REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE')])
    titleRow.font = { bold: true, size: 16 }
    sheet.mergeCells(titleRow.number, 1, titleRow.number, titleMergeCols)
    titleRow.alignment = { horizontal: 'left' }

    sheet.mergeCells(2, 1, 2, titleMergeCols)
    sheet.getCell(2, 1).value = filter
    sheet.getCell(2, 1).font = { size: 12 }
    sheet.getCell(2, 1).alignment = { horizontal: 'left', vertical: 'middle' }

    // Main Table Header
    const headCells = [
        t('REPORT.TABLE.REMUNERATION.#NO'),
        t('REPORT.TABLE.REMUNERATION.BILL_ID'),
        t('REPORT.TABLE.REMUNERATION.CN'),
        t('REPORT.TABLE.REMUNERATION.BRANCH_CN'),
        t('REPORT.TABLE.REMUNERATION.PATIENT_SN_CODE'),
        t('REPORT.TABLE.REMUNERATION.PATIENT_NAME'),
        t('REPORT.TABLE.REMUNERATION.ITEM'),
        t('REPORT.TABLE.REMUNERATION.PAYMENT'),
        t('REPORT.TABLE.REMUNERATION.CASH'),
        t('REPORT.TABLE.REMUNERATION.TRANSFER'),
        t('REPORT.TABLE.REMUNERATION.DEBIT'),
        t('REPORT.TABLE.REMUNERATION.CREDIT'),
        t('REPORT.TABLE.REMUNERATION.TREATMENT_RIGHT'),
        t('REPORT.TABLE.REMUNERATION.ADVANCE'),
        ...(hasCrm ? [
            t('REPORT.TABLE.REMUNERATION.VOUCHER'),
            t('REPORT.TABLE.REMUNERATION.PROMOTION'),
        ] : []),
        t('REPORT.TABLE.REMUNERATION.NAME_CLINICFEE'),
        t('REPORT.TABLE.REMUNERATION.PRICE_CLINICFEE'),
        t('REPORT.TABLE.REMUNERATION.DF_PERCEN'),
        t('REPORT.TABLE.REMUNERATION.DF'),
        t('REPORT.TABLE.REMUNERATION.CREDIT_PERCEN'),
        t('REPORT.TABLE.REMUNERATION.CREDIT_DF'),
        t('REPORT.TABLE.REMUNERATION.TREATMENT_RIGHT_DF'),
        t('REPORT.TABLE.REMUNERATION.NET_DF'),
    ]
    sheet.addRow([])
    const mainHeader = sheet.addRow(headCells)
    mainHeader.font = { bold: true, size: 12 }
    mainHeader.alignment = { horizontal: 'center', vertical: 'middle' }

    // Main Table Data
    let rowIdx = 1
    data.rows.forEach((salary: any) => {
        // Doctor name row
        sheet.addRow([`${t('REPORT.FILTER.DOCTOR')}: ${doctorName(salary.doctorId) || salary.doctor || ''}`])
        // Date row
        const grouped = _.groupBy(salary.table, (item) => toBuddhistYear(moment(item.date), 'DD/MM/YYYY'))
        Object.entries(grouped).forEach(([dateStr, items]: [string, any]) => {
            sheet.addRow([`${t('MOMENT_AT')} ${dateStr}`])
            items.forEach((d: any) => {

                console.log('export:',d)
                sheet.addRow([
                    rowIdx++,
                    d.billNo || '-',
                    d.cnNumber || '-',
                    d.branchCnNumber || '-',
                    d.snCode || '-',
                    d.patientFullname || '-',
                    d.list || '-',
                    numberFormat(d.amountPaid),
                    numberFormat(d.amountCash),
                    numberFormat(d.amountTransfer),
                    numberFormat(d.amountDebit),
                    numberFormat(d.amountCredit),
                    numberFormat(d.amountTreatmentRight || 0),
                    numberFormat(d.amountAdvance),
                    ...(hasCrm ? [
                        numberFormat(d.amountVoucher || 0),
                        numberFormat(d.amountPromotion || 0),
                    ] : []),
                    d.clinicFeeName || '-',
                    numberFormat(d.clinicFeePrice),
                    d.dfPercentOriginal || '',
                    numberFormat(d.dfPaid),
                    numberFormat(d.creditCardFee),
                    numberFormat(d.creditCost),
                    numberFormat(d.dfLostTreatment),
                    numberFormat(d.dfNet),
                ])
            })
            // Sum row for this date — Number() ป้องกัน BE คืน DECIMAL string ที่ทำให้ _.sumBy concat strings
            const num = (k: string) => _.sumBy(items, (o: any) => Number(o[k]) || 0)
            const sumRow: any[] = [
                '', '', '', '', '',
                t('REPORT.TITLE.SUM'),
                '',
                numberFormat(num('amountPaid')),
                numberFormat(num('amountCash')),
                numberFormat(num('amountTransfer')),
                numberFormat(num('amountDebit')),
                numberFormat(num('amountCredit')),
                numberFormat(num('amountTreatmentRight')),
                numberFormat(num('amountAdvance')),
                ...(hasCrm ? [numberFormat(num('amountVoucher')), numberFormat(num('amountPromotion'))] : []),
                '',
                numberFormat(num('clinicFeePrice')),
                '',
                numberFormat(num('dfPaid')),
                numberFormat(_.sumBy(items, (o: any) => Number(o.creditCost) > 0 ? Number(o.creditCardFee) || 0 : 0)),
                numberFormat(_.sumBy(items, (o: any) => Number(o.creditCost || 0) ), 3, 3),
                numberFormat(num('dfLostTreatment')),
                numberFormat(num('dfNet')),
            ]
            sheet.addRow(sumRow)
        })
    })

    // Lab Table
    sheet.addRow([])
    sheet.addRow([t('LAB Report')])
    const headLabCells = [
        t('REPORT.TABLE.REMUNERATION.#NO'),
        t('REPORT.TABLE.REMUNERATION.DOCTOR'),
        t('REPORT.TABLE.REMUNERATION.CN'),
        t('REPORT.TABLE.REMUNERATION.BRANCH_CN'),
        t('REPORT.TABLE.REMUNERATION.PATIENT_SN_CODE'),
        t('REPORT.TABLE.REMUNERATION.PATIENT_NAME'),
        t('REPORT.TABLE.REMUNERATION.DESCRIPTION'),
        t('REPORT.TABLE.REMUNERATION.LAB_NAME'),
        t('REPORT.TABLE.REMUNERATION.JOB'),
        t('LAB Fee'),
        t('DF LAB Fee'),
    ]
    const labHeader = sheet.addRow(headLabCells)
    labHeader.font = { bold: true, size: 12 }
    labHeader.alignment = { horizontal: 'center', vertical: 'middle' }
    let labIdx = 1

    // if (!data.rowLab || data.rowLab.length === 0) {
    //     const noDataRow = sheet.addRow([t('REPORT.TITLE.NO_DATA')])
    //     sheet.mergeCells(noDataRow.number, 1, noDataRow.number, sheet.columns.length)
    //     noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
    //     noDataRow.alignment = { horizontal: 'center' }
    //     const buf = await workbook.xlsx.writeBuffer()
    //     saveAs(
    //         new Blob([buf]),
    //         `${t('REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE')}_${moment().format('YYYYMMDD')}.xlsx`
    //     )
    //     return
    // }

    data.rowLab.forEach((item: any) => {
        sheet.addRow([`${t('MOMENT_AT')} ${toBuddhistYear(moment(item.date), 'DD/MM/YYYY')}`])
        item.table.forEach((d: any) => {
            sheet.addRow([
                labIdx++,
                d.dentist || '-',
                d.cnNumber || '-',
                d.branchCnNumber || '-',
                d.snCode || '-',
                d.patientFullname || '-',
                d.remark || '-',
                d.lab || '-',
                d.operativeName || '-',
                numberFormat(d.labFee),
                numberFormat(d.dfLabFee),
            ])
        })
        // Sum row for this date
        sheet.addRow(['', '', '', '', '', '', '', '', t('REPORT.TITLE.SUM'), numberFormat(_.sumBy(item.table, 'labFee')), numberFormat(_.sumBy(item.table, 'dfLabFee'))])
    })

    // DF Table
    sheet.addRow([])
    sheet.addRow([t('Dentist Fee')])
    const headDFCells = [
        t('REPORT.TABLE.REMUNERATION.#NO'),
        t('REPORT.TABLE.REMUNERATION.DOCTOR'),
        t('REPORT.TABLE.REMUNERATION.NET_PRICE'),
        t('ค่าประกันมือ'),
        t('REPORT.TABLE.REMUNERATION.SUM_PAID'),
        t('REPORT.TABLE.REMUNERATION.DF'),
        t('REPORT.TABLE.REMUNERATION.CREDIT_DF'),
        t('REPORT.TABLE.REMUNERATION.TREATMENT_RIGHT_DF'),
        t('REPORT.TABLE.REMUNERATION.SUM_DF'),
        t('DF LAB'),
        t('Net DF'),
    ]
    const dfHeader = sheet.addRow(headDFCells)
    dfHeader.font = { bold: true, size: 12 }
    dfHeader.alignment = { horizontal: 'center', vertical: 'middle' }
    let dfIdx = 1
    data.rowDf.forEach((d: any) => {
        sheet.addRow([
            dfIdx++,
            doctorName(d.doctorId) || d.doctor || '-',
            numberFormat(d.totalAmount),
            numberFormat(d.handInsurance),
            numberFormat(d.amountPaid),
            numberFormat(d.amountDf),
            numberFormat(d.dfCredit || 0),
            numberFormat(d.dfLostTreatment),
            numberFormat(d.dfLostCreditAndTreatment),
            numberFormat(d.dfLabFee),
            numberFormat(d.dfNet),
        ])
    })
    // Sum row for DF
    sheet.addRow([
        '', t('REPORT.TITLE.SUM'),
        numberFormat(_.sumBy(data.rowDf, 'totalAmount')),
        numberFormat(_.sumBy(data.rowDf, 'handInsurance')),
        numberFormat(_.sumBy(data.rowDf, 'amountPaid')),
        numberFormat(_.sumBy(data.rowDf, 'amountDf')),
        numberFormat(_.sumBy(data.rowDf, (o: any) => Number(o.dfCredit || 0))),

        numberFormat(_.sumBy(data.rowDf, 'dfLostTreatment')),
        numberFormat(_.sumBy(data.rowDf, 'dfLostCreditAndTreatment')),
        numberFormat(_.sumBy(data.rowDf, 'dfLabFee')),
        numberFormat(_.sumBy(data.rowDf, 'dfNet')),
    ])

    // Total Income Summary
    sheet.addRow([])
    const incomeTitleRow = sheet.addRow([t('Total Income Summary')])
    incomeTitleRow.font = { bold: true, size: 14 }
    incomeTitleRow.alignment = { horizontal: 'left' }

    let sumAmountPaid = 0
    let sumAmountCash = 0
    let sumAmountTransfer = 0
    let sumAmountDebit = 0
    let sumAmountCredit = 0
    let sumAmountTreatmentRight = 0
    let sumAmountAdvance = 0
    let sumAmountVoucher = 0
    let sumAmountPromotion = 0
    let dfNet = 0
    let dfLabFee = 0
    data.rows.forEach((salary: any) => {
        (salary?.table || []).forEach((d: any) => {
            sumAmountPaid += Number(d.amountPaid || 0)
            sumAmountCash += Number(d.amountCash || 0)
            sumAmountTransfer += Number(d.amountTransfer || 0)
            sumAmountDebit += Number(d.amountDebit || 0)
            sumAmountCredit += Number(d.amountCredit || 0)
            sumAmountTreatmentRight += Number(d.amountTreatmentRight || 0)
            sumAmountAdvance += Number(d.amountAdvance || 0)
            sumAmountVoucher += Number(d.amountVoucher || 0)
            sumAmountPromotion += Number(d.amountPromotion || 0)
        })
    })
    if (data.rowDf && data.rowDf.length > 0) {
        data.rowDf.forEach((d: any) => {
            dfNet += Number(d.dfNet || 0)
            dfLabFee += Number(d.dfLabFee || 0)
        })
    }
    const netClinic = sumAmountPaid - dfNet < 0 ? 0 : sumAmountPaid - dfNet

    const incomeHeadCells = [
        t('REPORT.TABLE.REMUNERATION.INCOME'),
        t('REPORT.TABLE.REMUNERATION.NET_CLINIC'),
        t('REPORT.TABLE.REMUNERATION.DF_NET'),
        t('REPORT.TABLE.REMUNERATION.DENTIST_FREE'),
        t('REPORT.TABLE.REMUNERATION.DF_LAB'),
        t('REPORT.TABLE.REMUNERATION.CASH'),
        t('REPORT.TABLE.REMUNERATION.TRANSFER_'),
        t('REPORT.TABLE.REMUNERATION.DEBIT'),
        t('REPORT.TABLE.REMUNERATION.CREDIT'),
        t('REPORT.TABLE.REMUNERATION.TREATMENT_RIGHT'),
        t('REPORT.TABLE.REMUNERATION.ADVANCE'),
        ...(hasCrm ? [
            t('REPORT.TABLE.REMUNERATION.VOUCHER'),
            t('REPORT.TABLE.REMUNERATION.PROMOTION'),
        ] : []),
    ]
    const incomeHeader = sheet.addRow(incomeHeadCells)
    incomeHeader.font = { bold: true, size: 12 }
    incomeHeader.alignment = { horizontal: 'center', vertical: 'middle' }
    sheet.addRow([
        numberFormat(sumAmountPaid),
        numberFormat(netClinic),
        numberFormat(dfNet),
        numberFormat(dfNet + dfLabFee),
        numberFormat(dfLabFee),
        numberFormat(sumAmountCash),
        numberFormat(sumAmountTransfer),
        numberFormat(sumAmountDebit),
        numberFormat(sumAmountCredit),
        numberFormat(sumAmountTreatmentRight),
        numberFormat(sumAmountAdvance),
        ...(hasCrm ? [
            numberFormat(sumAmountVoucher),
            numberFormat(sumAmountPromotion),
        ] : []),
    ])

    // Save file
    forceTextOnDateCells(workbook)
    const buffer = await workbook.xlsx.writeBuffer()
    const timestamp = moment().format('YYYYMMDD_HHmmss')
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `${t('REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE')}_${timestamp}.xlsx`)
}

export default ExportToExcel 